type LeadMcwsResponse = {
    createUpdateLeadMcwsApi: {
        success: boolean;
        message: string | null;
        leadId: number;
        leadToken: string;
        errorCode?: string;
    };
};

export const createMcwsLead = async (requestInput: LeadV1Request) => {
    return await fetch(`${process.env.GATSBY_CC_GQL_URL}/graphql`, {
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Method': 'POST',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                mutation createUpdateLeadMcwsApi($input: LeadInputMcwsApi!
                ) {
                    createUpdateLeadMcwsApi(
                        input: $input
                    ) {
                        action
                        leadId
                        leadToken
                        message
                        success
                        errorCode
                    }
                }
            `,
            variables: {
                input: { ...requestInput },
            },
        }),
    }).then((res): Promise<{ data: LeadMcwsResponse }> => res.json());
};
